import { render } from "./ConsultarOrcamentoPDF.vue?vue&type=template&id=17e3dedc&scoped=true"
import script from "./ConsultarOrcamentoPDF.vue?vue&type=script&lang=js"
export * from "./ConsultarOrcamentoPDF.vue?vue&type=script&lang=js"

import "./ConsultarOrcamentoPDF.vue?vue&type=style&index=0&id=17e3dedc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17e3dedc"]])

export default __exports__